import { QuestionIcon, Button } from "@stacklet/ui";
import { useSearchParams } from "react-router";

export function HelpDrawerTrigger() {
  const [searchParams, setSearchParams] = useSearchParams();

  function handleToggleHelp() {
    const newParams = new URLSearchParams(searchParams);
    if (searchParams.get("help") === "true") {
      newParams.delete("help");
    } else {
      newParams.set("help", "true");
    }
    setSearchParams(newParams);
  }

  return (
    <Button
      IconLeft={<QuestionIcon className="h-5 w-5" />}
      onPress={handleToggleHelp}
      variant="plain"
    >
      <div>Show Help</div>
    </Button>
  );
}
